module.exports = function ($, M) {
  'use strict';

  var isProfileLoaded = false;

  // Headless version (hidden header and footer) support
  const urlParams = new URL(window.location.href).searchParams;
  if (urlParams.get('headless') !== null) {
    $('body').addClass('headless');
  }

  /**
   * Profile dropdown
   */
  var $profileInner = $('.header-profile-inner'),
    $profileDetails = $('.profile-details'),
    $headerInfoCard = $('.header-info-card'),
    $dropdownArrow = $('.header-dropdown-arrow');

  function toggleProfileDropDown() {
    $profileInner.toggleClass('is-active');
    $headerInfoCard.toggleClass('is-active');
    $dropdownArrow.toggleClass('is-active');

    if (!isProfileLoaded) {
      $.get('/ajax/user/profile/', function (resp) {
        resp.user = M.user.username;
        var html = M.renderer.render('header-profile-content', resp);
        $profileDetails.html(html);
        animateProgressBar();
      });
      isProfileLoaded = true;
    }
  }

  function animateProgressBar() {
    var $profileProgressBar = $('.js-progress-bar'),
      progress = $profileProgressBar.attr('data-progress');
    $profileProgressBar.animate({
      width: progress * 100 + '%',
    });
  }

  $('.js-info-toggle').on('click', function (e) {
    toggleProfileDropDown();
    e.stopPropagation(); // needed for document click
  });

  $(document).on('click', function (e) {
    if (
      $profileInner.hasClass('is-active') &&
      $(e.target).closest('ul')[0] !== $profileInner[0]
    ) {
      toggleProfileDropDown();
    }
  });
};
